export const XBIT_RELAY_SWEEP_PERMISSION_RESOURCE = 'xbit-relay:sweep';

export const SWEEP_ORDER_BY = ['lastActive', 'balance'] as const;
export const SWEEP_ORDER_DIRECTION = ['DESC', 'ASC'] as const;

export const SWEEP_STATUSES = ['PROCESSING', 'SUCCESS', 'FAILED', 'SKIPPED'] as const;

// Reuse the deposits provider as the seed for the chain-list lookup only.
export { DEFAULT_DEPOSITS_PROVIDER as DEFAULT_SWEEP_PROVIDER } from '../deposits/constants';
